// Add your custom JS here.

(function ($) {
    $('.slider-home').slick({
        dots: true,
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        arrows: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false
            }
        }]
    });
    $('.slide-galeria').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: true
    });

    $('.slider-depoimentos').slick({
        dots: false,
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        arrows: true,
        responsive: [
           {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 780,
              settings: {
                slidesToShow: 1,
              }
            },
        ]
    });
    

})(jQuery);